import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M28.696 1.985A19.921 19.921 0 0 0 20 0a19.92 19.92 0 0 0-8.696 1.985L9.565 20l1.74 18.016A19.92 19.92 0 0 0 20 40c3.116 0 6.066-.713 8.696-1.984L30.435 20l-1.74-18.015Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m20 13.043 1.726 5.315h5.588l-4.52 3.284 1.726 5.314L20 23.672l-4.52 3.284 1.726-5.314-4.52-3.284h5.587L20 13.043Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M11.304 1.985C4.614 5.219 0 12.07 0 20s4.615 14.78 11.304 18.016V1.985Z"
}, null, -1), d = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M28.696 1.985v36.03C35.386 34.782 40 27.93 40 20S35.386 5.22 28.696 1.985Z"
}, null, -1), h = [
  n,
  s,
  c,
  d
];
function i(_, r) {
  return l(), e("svg", o, [...h]);
}
const f = { render: i };
export {
  f as default,
  i as render
};
